// <template>
//     <div class="help">
//         <hd title="法律条款和隐私政策"></hd>
//         <ul>
//             <li v-touch:tap="jump(1)">响车车平台协议</li>
//             <li v-touch:tap="jump(2)">车辆租赁合同</li>
//             <li v-touch:tap="jump(3)">隐私政策</li>
// 			<li v-touch:tap="jump(4)">证照信息</li>
//         </ul>
//     </div>
// </template>
// <script>
    module.exports = {
        methods: {
            jump: function(index) {
                switch (index) {
                    case 1:
                        location.href ="static_page.html#!/platformProtocol"
                        break;
                    case 2:
                        location.href ="static_page.html#!/leasingContract"
                        break;
                    case 3:
                        location.href ="static_page.html#!/privacyPolicy"
                        break;
					case 4:
						location.href ="static_page.html#!/licenseInformation"
						break;
                }
            }
        },
        components: {
            'hd': require('c/near_powerstation/header.vue')
        }
    }
// </script>
// <style lang="sass" scoped>
// .help{
//     width:100%;
//     min-height:100%;
//     padding-top:0.01rem;
//     box-sizing:border-box;
//     ul{
//         width: 100%;
//         padding-left: .32rem;
//         box-sizing:border-box;
//         background: #FFFFFF;
//         border-bottom: 1px solid #DDDDDD;
//         border-top: 1px solid #DDDDDD;
//         margin-top:.213333rem;
//         li{
//             width: 100%;
//             height: 1.146667rem;
//             line-height: 1.146667rem;
//             border-bottom: 1px solid #DDDDDD;
//             font-size: .426667rem;
//             color: #252F3A;
//             position:relative;
//             &:last-child{
//                 border: none;
//             }
//             &:before{
//                 content: "";
//                 position: absolute;
//                 width: .213333rem;
//                 height: .213333rem;
//                 right: .373333rem;
//                 top: 50%;
//                 border-top: .03rem solid #666D75;
//                 border-right: .03rem solid #666D75;
//                 transform: translateY(-50%) rotate(45deg);
//             }
//         }
//     } 
// }
// </style>
//
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/static_page/law.vue